var map = {
	"./1. Old Mission PNG.png": 235,
	"./bloomberg.png": 615,
	"./hrt.png": 82,
	"./jane_street.png": 474,
	"./old_mission.png": 696,
	"./palantir.png": 385,
	"./roblox.png": 504,
	"./sixth_street.png": 344,
	"./sponsor_info": 291,
	"./sponsor_info.js": 291,
	"./visa.png": 741
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 868;